/**
 * 規約同意
 */
class AgreementController{
    constructor() {
    }
    /**
     * 初期化
     */
    init(){
        this.initEvents();
    }

    /* イベント初期化 */
    initEvents(){
        /* 同意チェックボックス */
        const agreement = document.querySelector('input#agreement');
        if(agreement){
            agreement.addEventListener('change',(e)=>{
                this.onChangeAgreement(e);
            });
        }
    }
    /**
     * 同意チェック
     * @param e
     */
    onChangeAgreement(e){
        const agreement = document.querySelector('input#agreement:checked');

        let submit_with_agree;
        if(document.getElementById('checkout_with_agree')){
          //会員登録ページ
          submit_with_agree = document.getElementById('checkout_with_agree');
        }else if(document.querySelector('input#agreement')){
          //カートページ
          submit_with_agree = document.querySelector(document.querySelector('input#agreement').dataset['target']);
        }

        if(agreement){
            submit_with_agree.classList.remove('disabled');
            submit_with_agree.disabled = false;
        }else{
            submit_with_agree.classList.add('disabled');
            submit_with_agree.disabled = true;
        }
    }
}
window.addEventListener('DOMContentLoaded',(e) => {
    const ac = new AgreementController();
    ac.init();
});